import { endPoints, getEventServiceEndPoint } from "./base-url/api-constants";
import { apiService } from "./base-api-service/base-api-service";
import { readCookie } from "../Util/helper";
import { formatDateTime } from "./MasterData";
import { v4 as UUID4 } from "uuid";

class EventService {
  EventService(url: any) {
    return getEventServiceEndPoint(url);
  }

  EventPost(data: any, eventType: any, eventSubType: any, topicName: any) {
    const jwtToken = readCookie("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    const authEndpoint = this.EventService(`${endPoints.eventService.CREATE_EVENT}`);
    const eventData = {
      id: UUID4(),
      eventId: UUID4(),
      actorId: UUID4(),
      eventPublishedOn: formatDateTime(new Date()),
      eventType: eventType,
      eventSubType: eventSubType,
      data: data,
      context: {
        authToken: null,
        sourceAppCD: null,
        topicName: topicName,
      },
    };
    return apiService.post(authEndpoint, eventData, headers);
  }
}

export default new EventService();
